import { Box, Skeleton } from "@mui/material";
import React from "react";

export const BidDetailsSkeleton: React.FC = () => {
  return (
    <Box>
      <Box display="flex" justifyContent="space-between" width="100%">
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="40%"
          height={30}
        />
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="30%"
          height={30}
        />
      </Box>
      <Box pt={2.5} display="flex" justifyContent="space-between">
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="30%"
          height={25}
        />
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="40%"
          height={25}
        />
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="27%"
          height={25}
        />
      </Box>
      <Box pt={2.5} display="flex" justifyContent="space-between">
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="30%"
          height={25}
        />
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="40%"
          height={25}
        />
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="27%"
          height={25}
        />
      </Box>
      <Box pt={2.5} display="flex" justifyContent="space-between">
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="30%"
          height={25}
        />
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="40%"
          height={25}
        />
        <Skeleton
          variant="rectangular"
          animation="wave"
          width="27%"
          height={25}
        />
      </Box>
      <Box width="40%">
        <Box pt={10} display="flex" columnGap={2.5} alignItems="center">
          <Skeleton
            variant="rectangular"
            animation="wave"
            width="17.5%"
            height={40}
          />
          <Skeleton
            variant="rectangular"
            animation="wave"
            width="17.5%"
            height={40}
          />
          <Skeleton
            variant="rectangular"
            animation="wave"
            width="17.5%"
            height={40}
          />
          <Skeleton
            variant="rectangular"
            animation="wave"
            width="17.5%"
            height={40}
          />
          <Skeleton
            variant="rectangular"
            animation="wave"
            width="17.5%"
            height={40}
          />
          <Box display="flex" columnGap={1} alignItems="center">
            <Skeleton
              variant="circular"
              animation="wave"
              width={16}
              height={16}
            />
            <Skeleton
              variant="circular"
              animation="wave"
              width={16}
              height={16}
            />
            <Skeleton
              variant="circular"
              animation="wave"
              width={16}
              height={16}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
